import type { IPesquisaGateWay } from "./PesquisaGateWay";

import type { HttpClient } from "@/core/services/protocols/types";
import { IParamsPesquisa } from "./type";
import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";

@injectable()
export default class GetPesquisaGateWay implements IPesquisaGateWay {
  @inject(DITypes.INDICADORES_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async createSurvey(params: IParamsPesquisa): Promise<void> {
    await this.httpClient.post<IParamsPesquisa>({
      url: "v1/indicadores/pesquisa-reacao",
      body: {
        ...params
      }
    });
  }
}
